import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index/index'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  routes: [{
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      hideInMenu: true,
      slots: ''
    },
    component: () => import('@/views/login/login')
  },
  {
    path: '/index',
    name: 'Home',
    meta: {
      title: '首页',
      hideInMenu: true,
      requireAuth: true,
      slots: ''
    },
    component: Index,
    redirect: '/index/chartStatistics',
    children: [{
      path: 'preface',
      meta: {
        title: '基础表格',
        name: '',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/preface/preface')
    },
    {
      path: 'chartStatistics',
      meta: {
        title: '数据统计',
        name: '图表统计',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/statistics/chart/chart')
    },
    {
      path: 'userStatistics',
      meta: {
        title: '数据统计',
        name: '用户信息',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/statistics/user/user')
    },
    {
      path: 'userDetail',
      meta: {
        title: '数据统计',
        name: '用户信息',
        slots: '用户信息详情',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/statistics/user/detail')
    },
    {
      path: 'carousel',
      meta: {
        title: '轮播图',
        name: '管理列表',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/carouselManage/carousel/carousel')
    },
    {
      path: 'drafts',
      meta: {
        title: '每日阅读',
        name: '草稿箱',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/reading/drafts/drafts')
    },
    {
      path: 'releasing',
      meta: {
        title: '每日阅读',
        name: '发布中',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/reading/releasing/releasing')
    },
    {
      path: 'revoked',
      meta: {
        title: '每日阅读',
        name: '已下架',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/reading/revoked/revoked')
    },
    {
      path: 'comments',
      meta: {
        title: '每日阅读',
        name: '评论管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/reading/comments/comments')
    },
    {
      path: 'calendar',
      meta: {
        title: '黄历',
        name: '黄历管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/calendarManage/calendar/calendar')
    },
    {
      path: 'divination',
      meta: {
        title: '占卜',
        name: '卦象管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/divine/divination/divination')
    },
    {
      path: 'notes',
      meta: {
        title: '占卜',
        name: '卦象管理',
        slots: '笔记列表',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/divine/divination/notes')
    },
    {
      path: 'article',
      meta: {
        title: '占卜',
        name: '相关文章',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/divine/article/article')
    },
    {
      path: 'share',
      meta: {
        title: '占卜',
        name: '卦象解锁管理',
        slots: '分享解锁',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/deciphering/share/share')
    },
    {
      path: 'payment',
      meta: {
        title: '占卜',
        name: '卦象解锁管理',
        slots: '支付订单',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/deciphering/payment/payment')
    },
    {
      path: 'notice',
      meta: {
        title: '通知管理',
        name: '管理列表',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/noticeManage/notice/notice')
    },
    {
      path: 'feedback',
      meta: {
        title: '用户反馈管理',
        name: '管理列表',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/feedbackManage/feedback/feedback')
    },
    {
      path: 'edition',
      meta: {
        title: '系统管理',
        name: '版本管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/systemManage/edition/edition')
    },
    {
      path: 'h5JumpUrl',
      meta: {
        title: '系统管理',
        name: '小鹅通报名链接',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/systemManage/jump/jump')
    }, {
      path: 'protocolYs',
      meta: {
        title: '系统管理',
        name: '隐私协议',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/systemManage/protocol/protocol')
    },
    {
      path: 'protocolFw',
      meta: {
        title: '系统管理',
        name: '服务协议',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/systemManage/protocol/protocol')
    },
    {
      path: 'book',
      meta: {
        title: '系统管理',
        name: '图书管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/systemManage/book/book')
    },
    {
      path: 'applePay',
      meta: {
        title: '系统管理',
        name: '支付设置',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/systemManage/pay/pay')
    },
    {
      path: 'bookMember',
      meta: {
        title: '数据',
        name: '用户查询',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/systemManage/book/user')
    },
    {
      path: 'campPeriod',
      meta: {
        title: '课程管理',
        name: '训练营管理',
        slots: '营期管理',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/trainingCamp/campPeriod/list')
    },
    {
      path: 'campPeriodAdd',
      meta: {
        title: '课程管理',
        name: '训练营管理',
        slots: '添加营期',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/trainingCamp/campPeriod/detail')
    },
    {
      path: 'campPeriodEdit',
      meta: {
        title: '课程管理',
        name: '训练营管理',
        slots: '编辑营期',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/trainingCamp/campPeriod/detail')
    },
    {
      path: 'statistics',
      meta: {
        title: '课程管理',
        name: '训练营管理',
        slots: '数据统计',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/trainingCamp/statistics/StatisticsView')
    },
    {
      path: 'trainingCamp',
      meta: {
        title: '课程管理',
        name: '训练营管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/trainingCamp/index')
    },
    {
      path: 'imageAndText',
      meta: {
        title: '课程管理',
        name: '图文管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/imageAndText/imageAndText')
    },
    {
      path: 'video',
      meta: {
        title: '课程管理',
        name: '视频管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/video/video')
    },
    {
      path: 'audio',
      meta: {
        title: '课程管理',
        name: '音频管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/audio/audio')
    },
    {
      path: 'catalog',
      meta: {
        title: '课程管理',
        name: '目录管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/catalog/index')
    },
    {
      path: 'catalogEdit',
      meta: {
        title: '课程管理',
        name: '目录管理',
        slots: '编辑目录',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/catalog/edit')
    },
    {
      path: 'audio',
      meta: {
        title: '课程管理',
        name: '音频管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/audio/audio')
    },
    {
      path: 'material',
      meta: {
        title: '课程管理',
        name: '素材管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/material/material')
    },
    {
      path: 'gift',
      meta: {
        title: '课程管理',
        name: '教具礼品管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/gift/gift')
    },
    {
      path: 'order',
      meta: {
        title: '课程管理',
        name: '订单管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/order/order')
    },
    {
      path: 'certificate',
      meta: {
        title: '课程管理',
        name: '证书管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/certificate/certificate')
    },
    {
      path: 'certificateOp',
      meta: {
        title: '证书管理',
        name: '证书管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/certificate/subPages/detail')
    },
    {
      path: 'appointment',
      meta: {
        title: '课程管理',
        name: '预约管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/appointment/appointment')
    },
    {
      path: 'ticket',
      meta: {
        title: '课程管理',
        name: '优惠券管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/ticket/ticket')
    }, {
      path: 'member',
      meta: {
        title: '课程管理',
        name: '开通有赞会员',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/member/index')
    }, {
      path: 'ticketStatistics',
      meta: {
        title: '课程管理',
        name: '优惠券管理',
        slots: '数据统计',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/ticket/statistics/StatisticsView')
    }, {
      path: 'ticketOp',
      meta: {
        title: '课程管理',
        name: '优惠券管理',
        slots: '操作',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/ticket/detail')
    }, {
      path: 'examination',
      meta: {
        title: '课程管理',
        name: '考试管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/examination/main')
    }, {
      path: 'questionAdd',
      meta: {
        title: '课程管理',
        name: '考试管理',
        slots: '添加试题',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/examination/questionBank/questionEdit')
    },
    {
      path: 'questionEdit',
      meta: {
        title: '课程管理',
        name: '考试管理',
        slots: '编辑试题',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/examination/questionBank/questionEdit')
    },
    {
      path: 'examinationAdd',
      meta: {
        title: '课程管理',
        name: '考试管理',
        slots: '添加试卷',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/examination/testPaper/edit')
    },
    {
      path: 'examinationEdit',
      meta: {
        title: '课程管理',
        name: '考试管理',
        slots: '编辑试卷',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/examination/testPaper/edit')
    },
    {
      path: 'examinationDetail',
      meta: {
        title: '课程管理',
        name: '考试管理',
        slots: '预览试卷',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/examination/testPaper/preview')
    },
    {
      path: 'formList',
      meta: {
        title: '二级菜单',
        name: '三级菜单',
        slots: '菜单管理',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/articleManage/formTable/formList/formList')
    },
    {
      path: 'homework',
      meta: {
        title: '课程管理',
        name: '作业管理',
        slots: '',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/homework/index')
    },
    {
      path: 'homeworkStatics',
      meta: {
        title: '课程管理',
        name: '作业管理',
        slots: '数据',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/homework/statics')
    },
    {
      path: 'userProgressDetail',
      meta: {
        title: '课程管理',
        name: '数据统计',
        slots: '进度详情',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/trainingCamp/statistics/userProgressDetail.vue')
    },
    {
      path: 'newMemberEdit',
      meta: {
        title: '课程管理',
        name: '新人会员',
        slots: '编辑',
        hideInMenu: true
      },
      component: () => import('@/views/subPage/courseManage/member/edit')
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js